module.exports = __webpack_public_path__ + "img/search.d0b84971.jpg";